import initVuePhoneInput from '@atoms/twig-phone-input';

export const initOnboardingStepOne = () => {
  if (!document.querySelector('form[name="app_organization_onboarding_user"]')) {
    return;
  }

  const firstname = document.getElementById('app_organization_onboarding_user_firstname');
  const lastname = document.getElementById('app_organization_onboarding_user_lastname');
  const submit = document.getElementById('app_organization_onboarding_user_save');

  const form = document.querySelector('form[name="app_organization_onboarding_user"]');

  function validate() {
    submit.disabled = firstname.value.trim().length === 0
      || lastname.value.trim().length === 0;
  }

  [ firstname, lastname, submit ].forEach((input) => {
    [ 'change', 'input' ].forEach((event) => {
      input.addEventListener(event, () => {
        validate();
      });
    });
  });

  form.addEventListener('submit', () => {
    submit.classList.add('loading-btn');
  });

  initVuePhoneInput('vue-phone-input');
  validate();
};
